import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

import { paths } from './paths';

/** Keeps signed-in users out of login/register style pages. */
export function PublicRoute({ redirectTo, children }) {
  const { status, isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (status === 'initialising') return null;

  if (isAuthenticated) {
    // An unverified account cannot use the app yet, so verification wins over
    // any dashboard redirect.
    if (user && !user.is_email_verified) {
      return (
        <Navigate to={`${paths.verifyEmail}?email=${encodeURIComponent(user.email)}`} replace />
      );
    }
    // Signing in re-renders this guard before the login page can navigate, so
    // the page the user was sent here from has to be honoured here too.
    const from = location.state?.from;
    const roleHome =
      user?.role === 'STUDENT'
        ? paths.student.dashboard
        : user?.role === 'SUPER_ADMIN'
          ? paths.admin.overview
          : paths.home;
    const destination = redirectTo ?? (from ? `${from.pathname}${from.search ?? ''}` : roleHome);
    return <Navigate to={destination} replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
